import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-wave">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
          <path
            fill="#1A3A6B"
            fillOpacity="0.05"
            d="M0,192L48,208C96,224,192,256,288,261.3C384,267,480,245,576,218.7C672,192,768,160,864,165.3C960,171,1056,213,1152,224C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
          ></path>
        </svg>
      </div>

      <div className="container">
        <div className="footer-content">
          {/* Información principal */}
          <div className="footer-about">
            <div className="footer-logo">
              <img
                src="/assets/img/logo.png"
                alt="Logo Conectemos Chile"
                width="40"
                height="40"
                loading="lazy"
                style={{ width: '40px', height: '40px' }}
              />
              <h3>Conectemos Chile</h3>
            </div>
            <p>
              Centro de Atención Psicológica especializado en terapia de parejas e individual.
              Comprometidos con tu bienestar emocional en Santiago.
            </p>
          </div>

          {/* Enlaces rápidos */}
          <div className="footer-links-container">
            <h4 className="footer-heading">Enlaces Rápidos</h4>
            <ul className="footer-links">
              <li><a href="#home">Inicio</a></li>
              <li><a href="#about">Quiénes Somos</a></li>
              <li><a href="#professionals">Nuestros Profesionales</a></li>
              <li><a href="#why-us">Por Qué Elegirnos</a></li>
              <li><a href="#disorders">Trastornos que Tratamos</a></li>
              <li><a href="#prices">Precios</a></li>
              <li><a href="#testimonials">Testimonios</a></li>
              <li><a href="/agendar">Agendar</a></li>
              <li><a href="#contact">Contacto</a></li>
            </ul>
          </div>

          {/* Información de contacto */}
          <div className="footer-contact">
            <h4 className="footer-heading">Contáctanos</h4>
            <p>
              <i className="fas fa-map-marker-alt"></i> Bombero Adolfo Ossa 1010, Oficina 204, Santiago
            </p>
            <p>
              <i className="fas fa-phone"></i> +56 9 7800 9119
            </p>
            <p>
              <i className="fas fa-envelope"></i> conectemoscl@gmail.com
            </p>
            <p>
              <i className="fas fa-clock"></i> Lun-Vie: 9:00 - 20:00 | Sáb: 9:00 - 19:00 | Dom: 9:00 - 14:00
            </p>

            {/* Redes sociales */}
            <div className="footer-social">
              <a href="https://www.facebook.com/" aria-label="Facebook" className="social-link" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://www.instagram.com/conectemos.chile?igsh=MXNseDRxZGYyZGxwcA=="
                aria-label="Instagram"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a
                href="https://www.tiktok.com/@psicologo.ngel.da?_t=ZM-8zSsKIxiNRG&_r=1"
                aria-label="TikTok"
                className="social-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-tiktok"></i>
              </a>
              <a
                href="https://wa.me/56978009119?text=Hola,%20me%20gustaría%20agendar%20una%20consulta%20en%20Conectemos%20Chile"
                aria-label="WhatsApp"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Información legal y créditos */}
        <div className="footer-bottom">
          <p>&copy; 2026 Conectemos SpA · RUT 77.528.735-7 · <a href="/privacidad">Política de privacidad</a></p>
          <p className="developer-credit">
            Desarrollo web por{' '}
            <a href="https://www.wisestlabs.cl" target="_blank" rel="noopener noreferrer">
              Wisest Labs
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
